<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <div v-show="!mergeSuccessfully">
          {{ $t('Trying to merge account') }} ...
        </div>
        <div
          v-show="mergeSuccessfully"
          class="mb-3"
        >
          {{ $t('Merging complete.') }}
        </div>
        <Button
          v-show="mergeSuccessfully"
          color="secondary"
          @click="$router.push('/')"
        >
          {{ $t('Go to homepage') }}
        </Button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import {  ref, onMounted } from 'vue';
import Button from '@/components/input-components/Button.vue'
import { ProspectUserService } from '@/services/prospectuser.service'
import NotificationMessageService from "@/services/notificationmessage.service";
import { useI18n } from "vue-i18n"
import { useRoute } from 'vue-router'

defineOptions({ name: "MergeAccount" });

const mergeSuccessfully = ref(false)
const prospectUserService = new ProspectUserService()

const route = useRoute()
const { t } = useI18n()

onMounted(() => {
  const query = route.query
  if (query?.parameters) {
    prospectUserService
      .postMergeAccount(query.parameters as string)
      .then(() => {
        NotificationMessageService.showSuccess(
          t("Successfully added Email to your account .")
        )
        mergeSuccessfully.value = true
      })
      .catch(() => {
        NotificationMessageService.showError(
          t("Please try again later.")
        )
      })
  } else {
    NotificationMessageService.showError(
      t("Malformed link detected, please check the link in the email.")
    )
  }
})
</script>
